import { TableCell, TableRow } from '@mui/material';
import { memo } from 'react';
import Typography from '../../../../../../../../../../../../components/Typography/Typography';
import useGetGridItemWidth from '../../../../../../../../../../../../hooks/useGetGridItemWidth';
import useTeceoStyles from '../../../../../../../../../../../../useTeceoStyles';

interface SelloutTableHeaderProps {
  sizeNames: string[];
}

const SelloutTableHeader = ({ sizeNames }: SelloutTableHeaderProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { gridItemWidth } = useGetGridItemWidth();

  return (
    <TableRow style={{ height: '40px' }}>
      {sizeNames.map((sizeName) => (
        <TableCell key={sizeName} style={{ minWidth: gridItemWidth + 4 }}>
          <Typography noWrap className={teceoClasses.noTextTransform}>
            {sizeName}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );
};

export default memo(SelloutTableHeader);
